import styled from 'styled-components';
// import { Button as UnstyledButton } from '@Components';
import { ButtonGroup, MenuItem } from '@mui/material';

interface MenuItemProps {
	fitMenuToContent?: boolean;
	width?: number;
}

export const Wrapper = styled(ButtonGroup)``;
export const StyledMenuItem = styled(MenuItem)<MenuItemProps>`
    width: fitMenuToContent ? 'auto' : rem(width);
    minWidth: rem(width);
    zIndex: 1301;
`;
// export const Button = styled(UnstyledButton)<{ height: number; width: number }>`
// 	padding: ${rem(6)} ${rem(16)};
// 	height: ${({ height }) => rem(height)};
// 	width: ${({ width }) => rem(width)};
// `
